import { AsyncResult, callActionOrExecute, Cart, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';

function updateCartQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function updateCartInput(cart: Partial<Cart>): IDataServiceRequest {
    const query = updateCartQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateCart',
        true,
        'CartClass',
        'false',
        { bypassCache: 'get', returnEntity: 'Cart' },
        { cart: cart }
    );
}

export function updateCartAsync(context: IContext, partialCart: Partial<Cart>): AsyncResult<Cart> {
    const request = updateCartInput(partialCart);
    return callActionOrExecute<Cart>(request, context.callerContext);
}
